import getHostname from './get_hostname';

const getDomain = function getDomain(url = window.location.href) {
    const hostName = getHostname(url);
    let domain = hostName;

    if (hostName !== null) {
        const parts = hostName.split('.').reverse();

        if (parts !== null && parts.length > 1) {
            domain = `${parts[1]}.${parts[0]}`;

            if (
                hostName.toLowerCase().indexOf('.co.uk') !== -1 &&
                parts.length > 2
            ) {
                domain = `${parts[2]}.${domain}`;
            }
        }
    }

    return domain;
};

export default getDomain;